



































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import QuestionOfPaperType from "@/store/entities/questionOfPaperTypes";
import TestPaper from "@/store/entities/testPaper";

class PageTestQuestionRequest extends PageRequest {
  keyword: string;
  classTypeId: number = 11;
  parentId?: number;
  GradeType: number = 1;
  categoryId?: number;
  questionType: number = 0;
  degreeDifficulty: number = 1;
  testPaperId: string = "";
  sectionId?: number = 0;
}

@Component({})
export default class EditQuestionOfPaper extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  //filters
  pagerequest: PageTestQuestionRequest = new PageTestQuestionRequest();
  questionOfPaperType: QuestionOfPaperType = new QuestionOfPaperType();
  testPaperName: string = "";
  editModalShow: boolean = false;
  screenWidth: number = document.body.clientWidth - 200;
  multiTypes: any = [];
  data: any = [];
  showme: string = "测试";
  valueArray: any = [];
  newtabdata: any = [
    { value: 0, label: "判断题" },
    { value: 1, label: "单选题" },
    { value: 2, label: "多选题" },
    { value: 3, label: "填空题" },
    { value: 4, label: "计算题" },
    { value: 8, label: "解答题" },
    { value: 9, label: "作文题" },
    { value: 10, label: "探究题" },
    { value: 11, label: "材料题" },
    { value: 12, label: "实践题" },
    { value: 7, label: "选考单选" },
    { value: 5, label: "选考多选" },
    { value: 6, label: "选考计算" },
  ];
  cancel() {
    this.visibleChange(false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("save-success");
      this.$emit("input", value);
    } else {
      this.testPaperName = this.$store.state.testPaper.editTestPaper.name;
      this.data = this.$store.state.testPaper.cascaders.items;
      this.questionOfPaperType =
        this.$store.state.testPaper.questionOfPaperType;
      this.pagerequest.questionType = this.questionOfPaperType.questionType;
      this.pagerequest.degreeDifficulty =
        this.questionOfPaperType.questionDetail.degreeDifficulty;
      this.pagerequest.testPaperId = this.questionOfPaperType.id;
      this.getpage();
    }
  }
  async stateSwitching(id) {
    await this.$store.dispatch({
      type: "testQuestion/showStateSwitching",
      data: { id: id, questionType: this.pagerequest.questionType },
    });
    this.getpage();
  }
  async updateQuestion(row) {
    this.$store.commit("testQuestion/edit", row);
  }
  async deleteQuestion(id, questionId) {
    await this.$store.dispatch({
      type: "testQuestion/deletePaperOfQuestion",
      data: id,
    });
    this.getpaper();
    this.getpage();
    this.questionOfPaperType.questionDetail.imported.forEach(
      (item, index, arr) => {
        if (item === questionId) {
          arr.splice(index, 1);
        }
      }
    );
  }
  questionTypeChange(value) {
    this.pagerequest.questionType = value;
    this.$store.state.testQuestion.currentPage = 1;
    this.getpage();
  }

  cascaderSelect(value, selectedData) {
    if (value.length > 0) {
      this.pagerequest.categoryId = selectedData[selectedData.length - 1].value;
    } else {
      this.pagerequest.categoryId = null;
    }
    this.getpage();
  }
  handleRefresh() {
    this.loadCascaders();
    this.getpage();
  }
  get list() {
    return this.$store.state.testQuestion.list;
  }
  get loading() {
    return this.$store.state.testQuestion.loading;
  }
  selectChange(item) {
    this.pagerequest.classTypeId = item.id;
    this.valueArray = [];
    this.pagerequest.parentId = null;
    this.loadCascaders();
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("testQuestion/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("testQuestion/setPageSize", pagesize);
    this.getpage();
  }
  loadCascaders() {
    this.data = this.$store.state.testQuestion.cascaders.items;
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "testQuestion/getAllQuestionOfPaper",
      data: this.pagerequest,
    });
  }
  getpaper() {
    this.$store.dispatch({
      type: "testPaper/get",
      data: { id: this.pagerequest.testPaperId },
    });
  }
  UsdegreeDifficulty(value) {
    if (value == 1) {
      return "(A层次)";
    } else if (value == 2) {
      return "(B层次)";
    } else {
      return "(C层次)";
    }
  }
  get pageSize() {
    return 50; //this.$store.state.testQuestion.pageSize
  }
  get totalCount() {
    return this.$store.state.testQuestion.totalCount;
  }
  get currentPage() {
    return this.$store.state.testQuestion.currentPage;
  }
  getTypeName(classTypeId) {
    for (var item of this.multiTypes) {
      if (item.id === classTypeId) return item.text;
    }
  }
}
